document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.goto_to_rev');
  if (!trigger) return;

  e.preventDefault();

  const reviewsBlock = document.getElementById('judgeme_product_reviews');
  if (!reviewsBlock) return;
 
  reviewsBlock.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
 
  setTimeout(function () {
    const writeBtn = document.querySelector('.jdgm-write-rev-link');
    if (writeBtn) {
      writeBtn.click();
    }
  }, 700);
});

document.querySelectorAll('.goto_link').forEach(function(link) {
  link.addEventListener('click', function(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    const targetBlock = document.querySelector(targetId);

    if (targetBlock) {
      const offset = 50; 
      const elementPosition = targetBlock.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    }
  });
});
document.querySelectorAll('.show_popup').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const target = el.getAttribute('href');  
    const popup = document.querySelector(target);
    if (popup) {
      Fancybox.show([
        {
          src: target,
          type: "inline"
        }
      ]);
    }
  });
});